<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
        <div class="padding">
          <p>There is a silence that descends over the water when you're quiet, when you're paying attention to something other than the bustle and noise of the day. It isn't exactly silence, or meditation, but it carries sound differently.</p>
<br>
          <p>It makes you see the shapes of buildings and the shadows they cast in a different way. I looked at the facades above windows as I walked down here and I saw faces and carvings I never noticed before. Where they always here, or had they only arrived now I'm looking for them, looking for things that are out of place?</p>
<br>
          <p>This river was different yesterday, and it will change again tomorrow. Since this began, this feeling under my skin, I'm conscious of change, of the things that aren't here tomorrow that we don't attend to today.</p>
<br>
          <p>I think they vanish if we don't remember them. I can hear a voice in my head, familiar and yet strange at the same time. It whispers to me as I walk past monuments, through arcades and into the streets behind the market.</p>
<br>
          <p>It's not my voice.</p>
<br>
          <p>I think it's yours.</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '4',

  data () {
    return {
      title: 'Waves'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
